import axios from 'axios';
import Cookies from 'universal-cookie';

import { API_URL } from '@config/const';

export const baseURL = `${API_URL}`;

export const tokenConfig = (thunkAPI) => {
  let tokenValue;
  const { token } = thunkAPI.getState().auth;
  if (token) {
    tokenValue = `Token ${token}`;
  }
  return { headers: { Authorization: tokenValue } };
};
const queryTypes = { MUTATION: 'mutation', QUERY: 'query' };

export const setTokenHeader = (headers, { type }) => {
  if (type === queryTypes.QUERY) {
    return headers;
  }

  const cookies = new Cookies();
  const token = cookies.get('csrftoken');
  if (token) {
    headers.set('X-CSRFToken', `${token}`);
  }
  return headers;
};

const api = ({ thunkAPI }) =>
  axios.create({
    withCredentials: true,
    baseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...tokenConfig(thunkAPI).headers,
    },
  });

export const createInternalAPI = () => {
  const cookies = new Cookies();
  const token = cookies.get('csrftoken');

  return axios.create({
    baseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': `${token}`,
    },
    withCredentials: true,
  });
};

export default api;
